import React from "react";
import { Button } from "react-bootstrap";

import Layout from "../components/layout";
import mainWindow from "../images/MacBookPro3.png";
import { appStoreUrl } from '../constants';

const IndexPage = () => (
  <Layout>
    <div className="top">
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="font-weight-bold text-center">
              Transaction monitor for Braintree accounts
            </h1>
            <p className="my-5 text-center">
              Tramo is a menu bar app to monitor transactions in your Braintree
              accounts, so you can be informed about money flow. Get transaction
              details in Notification Center.
            </p>
            <div className="d-flex justify-content-center">
              <Button href={appStoreUrl} variant="outline-success">Download Now</Button>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-12 col-lg-8">
            <img className="img-fluid" src={mainWindow} />
          </div>
        </div>
      </div>
    </div>
  </Layout>
  // <React.Fragment>
  //   <div className="top d-flex flex-column">
  //     <div className="container">
  //       {/* <header className="navbar navbar-light navbar-expand-lg no-gutters"> */}
  //       <Navbar as="header" expand="lg" className="justify-content-between">
  //         <Navbar.Brand className="align-middle">
  //           <img className="mr-2" src={logo} width="30" height="30" alt="" />
  //           Tramo
  //         </Navbar.Brand>
  //         <Navbar.Toggle aria-controls="basic-navbar-nav" />
  //         <Navbar.Collapse id="basic-navbar-nav">
  //           <Nav className="ml-md-auto">
  //             {/* <Nav.Link className="mr-0 mr-lg-4 text-center">Features</Nav.Link>
  //             <Nav.Link className="mr-0 mr-lg-4 text-center">Pricing</Nav.Link> */}
  //             <Button variant="outline-success">Download</Button>
  //           </Nav>
  //         </Navbar.Collapse>
  //       </Navbar>
  //     </div>
  //     <div className="container mt-5">
  //       <div className="row justify-content-center">
  //         <div className="col-12">
  //           <h1 className="font-weight-bold text-center">
  //             Transaction monitor for Braintree accounts
  //           </h1>
  //           <p className="my-5 text-center">
  //             Tramo is a menu bar app to monitor transactions in your Braintree
  //             accounts, so you can be informed about money flow. Get transaction
  //             details in Notification Center.
  //           </p>
  //           <div className="d-flex justify-content-center">
  //             <Button variant="outline-success">Download Now</Button>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="row justify-content-center mt-5">
  //         <div className="col-12 col-lg-8">
  //           <img className="img-fluid" src={mainWindow} />
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //   {/* <div className="container my-5">
  //     <div className="row">
  //       <div className="col">
  //         <h2 className="text-center">Features</h2>
  //       </div>
  //     </div>
  //   </div>
  //   <div className="container my-5">
  //     <div className="row">
  //       <div className="col-5">
  //         <img
  //           className="img-fluid"
  //           src="https://via.placeholder.com/540x400"
  //         />
  //       </div>
  //       <div className="col-7 d-flex flex-column justify-content-center">
  //         <h3>Dashboard</h3>
  //         Get list of all transactions from all accounts in one place.
  //       </div>
  //     </div>
  //   </div>
  //   <div className="container my-5">
  //     <div className="row">
  //       <div className="col-7 d-flex flex-column justify-content-center">
  //         <h3>Lorem ipsum dolor sit amet</h3>
  //         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
  //         semper mauris nunc, ut luctus lacus facilisis sit amet. Maecenas
  //         mollis sem at enim vulputate aliquam.
  //       </div>
  //       <div className="col-5">
  //         <img
  //           className="img-fluid"
  //           src="https://via.placeholder.com/540x400"
  //         />
  //       </div>
  //     </div>
  //   </div>
  //   <div className="container my-5">
  //     <div className="row">
  //       <div className="col-5">
  //         <img
  //           className="img-fluid"
  //           src="https://via.placeholder.com/540x400"
  //         />
  //       </div>
  //       <div className="col-7 d-flex flex-column justify-content-center">
  //         <h3>Lorem ipsum dolor sit amet</h3>
  //         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
  //         semper mauris nunc, ut luctus lacus facilisis sit amet. Maecenas
  //         mollis sem at enim vulputate aliquam.
  //       </div>
  //     </div>
  //   </div>
  //   <div className="container py-5">
  //     <div className="row">
  //       <div className="col">
  //         <h2 className="text-center">Pricing</h2>
  //       </div>
  //     </div>
  //   </div>
  //   <div className="container py-5">
  //     <div className="row">
  //       <div className="col-3 offset-2 border rounded py-4">
  //         <h4 className="text-center">Basic</h4>
  //         <p className="text-center">Only 1 account</p>
  //         <h2 className="text-center">FREE</h2>
  //       </div>
  //       <div className="col-3 offset-2 border rounded py-4">
  //         <h4 className="text-center">Plus</h4>
  //         <p className="text-center">Unlimit accounts</p>
  //         <h2 className="text-center">$2.99</h2>
  //       </div>
  //     </div>
  //   </div> */}
  //   <div className="container py-5">
  //     <div className="row">
  //       <div className="col">
  //         <span className="text-center">© 2019, Mykola Voronin</span>
  //       </div>
  //       <div className="col">
  //         <div className="text-right w-100">
  //           <Link to="/privacy-policy">Privacy Policy</Link>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </React.Fragment>
);

export default IndexPage;
